import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=2442d79f&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2442d79f')) {
      api.createRecord('2442d79f', component.options)
    } else {
      api.reload('2442d79f', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=2442d79f&", function () {
      api.rerender('2442d79f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kSXH04e1mkX3/JS/comp/ImgFallback2.vue"
export default component.exports